
import { Options, setup, Vue } from 'vue-class-component';
import { useCheckToken } from './services/checkToken';
import { _ROUTER_NAME } from '@/enums';
import ChooseCenterCard from '@/components/elements/cards/chooseCenterCard/ChooseCenterCard.vue';
import { _var } from '@/enums/Common';
import { useRegister } from '@/views/staff/register/services/register';
import { useJoin } from '@/views/staff/register/services/join';

@Options({
	name: 'StaffRegister',
	components: { ChooseCenterCard },
})
export default class StaffRegister extends Vue {
	//----------------------- 🤍 Data 🤍 -----------------------//
	registerData = {
		account_exist: false,
		full_name: '',
		org_name: '',
	};
	typePassword = 'password';
	typePasswordConfirm = 'password';

	registerInfo = {
		name: '',
		username: '',
		password: '',
		password_confirmation: '',
	};

	errorData = {
		name: '',
		username: '',
		password: '',
		password_confirmation: '',
		status: false,
	};

	step = 0;

	orgs = [];

	token: string | null = '';

	//----------------------- 🤍 Setup 🤍 -----------------------//
	setup = setup(() => {
		const { checkToken__error, checkToken } = useCheckToken();
		const { register } = useRegister();
		const { join } = useJoin();
		return { checkToken, checkToken__error, register, join };
	});

	//----------------------- 🤍 Created 🤍 -----------------------//
	async created() {
		localStorage.clear();
		this.token = this.$route?.query?.token
			? this.$route?.query?.token + ''
			: null;
		if (!this.token) {
			return this.$router.push({
				name: _ROUTER_NAME.LOGIN,
			});
		}
		const res = await this.setup.checkToken({
			token: this.$route?.query?.token
				? this.$route?.query?.token + ''
				: '',
		});

		//@ts-ignore
		if (this.setup.checkToken__error?.response?.data?.errors) {
			await this.$router.push({
				name: _ROUTER_NAME.INVALID_TOKEN,
			});
		}
		if (res?.data) {
			this.registerData = res?.data;
		}
	}

	//----------------------- 🤍 Methods 🤍 -----------------------//
	onSubmit() {
		if (this.registerData?.account_exist) {
			this.step = 1;
			this.onRegisterJoin();
		} else {
			this.step = 1;
		}
	}

	async onRegisterSubmit() {
		this.errorData = {
			name: '',
			username: '',
			password: '',
			password_confirmation: '',
			status: false,
		};
		if (this.registerInfo.password.length < 8) {
			this.errorData.password =
				'Phải có ít nhất 8 ký tự (bao gồm chữ và số)';
			this.errorData.status = true;
		} else if (
			!/[0-9]/.test(this.registerInfo.password) ||
			!/[a-zA-Z]/.test(this.registerInfo.password)
		) {
			this.errorData.password = 'Mật khẩu bao gồm cả chữ và số';
			this.errorData.status = true;
		}
		if (
			this.registerInfo.password !=
			this.registerInfo.password_confirmation
		) {
			this.errorData.password_confirmation =
				'Xác nhận mật khẩu không khớp';
			this.errorData.status = true;
		}
		if (this.errorData.status) {
			return;
		}
		try {
			const { data } = await this.setup.register({
				account: {
					password: this.registerInfo.password,
					password_confirmation:
						this.registerInfo.password_confirmation,
				},
				token: this.token,
			});
			if (data) {
				localStorage.setItem(_var.TOKEN, data?.access_token);
				if (data?.orgs) {
					if (data?.orgs.length === 1) {
						localStorage.setItem(
							_var.SUBDOMAIN,
							data?.orgs[0].subdomain
						);
						return (window.location.href = '/');
					} else if (data?.orgs.length <= 0) {
						await this.$router.push('/signin');
					}
					this.step = 2;
					this.orgs = data?.orgs;
				}
			}
		} catch (e) {
			if (e?.response?.data?.errors) {
				await this.$router.push({
					name: _ROUTER_NAME.INVALID_TOKEN,
				});
			} else {
				this.errorData.password =
					e?.response?.data?.errors_by_field?.password.join(
						'<br/>'
					) ||
					'Mật khẩu không hợp lệ, vui lòng nhập ít nhất 8 ký tự (bao gồm chữ và số)';
				this.errorData.status = true;
			}
		}
	}

	async onRegisterJoin() {
		try {
			const { data } = await this.setup.join({
				token: this.token,
			});
			if (data) {
				localStorage.setItem(_var.TOKEN, data?.access_token);
				if (data?.orgs) {
					if (data?.orgs.length === 1) {
						localStorage.setItem(
							_var.SUBDOMAIN,
							data?.orgs[0].subdomain
						);
						return (window.location.href = '/');
					} else if (data?.orgs.length <= 0) {
						await this.$router.push('/signin');
					}
					this.step = 2;
					this.orgs = data?.orgs;
				}
			}
		} catch (e) {
			if (e?.response?.data?.errors) {
				await this.$router.push({
					name: _ROUTER_NAME.INVALID_TOKEN,
				});
			} else {
				this.errorData.password =
					e?.response?.data?.errors_by_field?.password.join(
						'<br/>'
					) ||
					'Mật khẩu không hợp lệ, vui lòng nhập ít nhất 8 ký tự (bao gồm chữ và số)';
				this.errorData.status = true;
			}
		}
	}

	selectOrg(org: any) {
		localStorage.setItem(_var.SUBDOMAIN, org.subdomain);
		return (window.location.href = '/');
	}
}
